import { Component, OnInit } from '@angular/core';
import { DisciplineService } from 'src/app/services/discipline.service';
import { EmailService } from 'src/app/services/email.service';
import { LocationService } from 'src/app/services/location.service';
import { TeamService } from 'src/app/services/team.service';

@Component({
  selector: 'contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.sass']
})
export class ContactComponent implements OnInit {

  disableInputs:boolean = false;
  mailSent:boolean = false;
  vestigingen:any = [];
  disciplines:any = [];
  vestigingPerDiscipline:any = {};
  email:any = {
    naam_aanmelder: "",
    naam_kind: "",
    email: "",
    telefoon: "",
    woonplaats: "",
    geboortedatum: "",
    school: "",
    mutualiteit: "",
    vestiging: "",
    discipline: "",
    bericht: ""
  };

  privacyCheckbox:any;

  errormsg:any = null;

  constructor(
    private locationService:LocationService,
    private disciplineService:DisciplineService,
    private emailService:EmailService,
    private teamService:TeamService
    ) { }

  ngOnInit(): void {
    this.locationService.getVestigingen().subscribe(data => {
      data.data.forEach((element: any) => {
        let item = this.locationService.populateVestiging(element);
        this.vestigingen.push(item);

        this.teamService.getTeamForVestiging(item.id).subscribe(data => {
          data.data.forEach((element: any) => {
            let member = this.teamService.populateTeamlid(element);
            for(let disc of member.disciplines) {
              this.disciplineService.getDiscipline(disc.id).subscribe(data => {
                let ddisc = this.disciplineService.populateDiscipline(data.data[0]);

                if(Object.keys(this.vestigingPerDiscipline).indexOf(ddisc.naam.toLowerCase()) == -1) {
                  this.vestigingPerDiscipline[ddisc.naam.toLowerCase()] = [];
                }

                let count = this.vestigingPerDiscipline[ddisc.naam.toLowerCase()].
                                    filter((v: { naam: string; }) => v.naam.toLowerCase() === item.naam.toLowerCase()).length;
                if(count == 0) {
                  this.vestigingPerDiscipline[ddisc.naam.toLowerCase()].push(item);
                }
              });
            }
          });
        });
      });
    });


    this.disciplineService.getDisciplines().subscribe(data => {
      data.data.forEach((element: any) => {
          let d = this.disciplineService.populateDiscipline(element);
          //console.log(d);
          if(d.id != 5 && d.id != 7) {
            this.disciplines.push(d);
          }
      });
      //this.disciplines.push({naam: "Andere"})
    });
  }

  onChange() {
    //console.log("switched to", this.email.vestiging);
  }

  sendEmail(e:any): void {
    e.preventDefault();

    this.errormsg = "";

    if(this.disableInputs) return;

    if(!this.privacyCheckbox) {
      this.errormsg = "Vul eerst alle velden in."
        return;
    }

    for(let v in this.email) {
      let value = this.email[v];
      if(!value || value == "") {
        this.errormsg = "Vul eerst alle velden in."
        return;
      }
    }

    this.disableInputs = true;

    this.emailService.sendMail(this.email).subscribe(response => {
      console.log("Send mail result:",response);
      this.mailSent = true;
      this.disableInputs = false;
    });
  }
}
